export default __webpack_public_path__ + "static/media/mongodb-original.416baad2.svg";